var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ProductUtility } from '@inter-ikea-kompis/utilities';
import { QrCode } from '@inter-ikea-kompis/component-qr-code';
import { Text } from '@inter-ikea-kompis/component-text';
import EprelQrStyle from './EprelQrStyle.js';
/**
 * Data-driven information listing.
 */
export default class EprelQr extends KompisElement {
    constructor() {
        super(...arguments);
        // Localized information. Deprecated - use "translations" instead.
        this.localizedInformation = null;
        // The translations retrieved from translations service.
        this.translations = null;
    }
    /**
     * @returns Template.
     */
    render() {
        // We want translations to be required, but since both props to provide translations are optional, this check is needed until localizedInformation is removed.
        if (!this.hasTranslations()) {
            // We can't throw an error because on the first render no props are set.
            return null;
        }
        const link = ProductUtility.getProductInformationSheetLink(this.product);
        if (!link) {
            return null;
        }
        return html `
			<style>
				${EprelQrStyle.getStyle({
            theme: this.theme
        })}
			</style>
			<div class="container">
				<kompis-text .theme="${this.theme}">
					${this.getTranslations().energyClassEprelQrDescription}
				</kompis-text>
				<kompis-qr-code .url="${link.href}"></kompis-qr-code>
			</div>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-qr-code', QrCode);
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    hasTranslations() {
        return !!this.translations || !!this.localizedInformation?.translations;
    }
    getTranslations() {
        const translations = this.translations
            ? this.translations
            : this.localizedInformation?.translations;
        return translations;
    }
}
__decorate([
    property({ type: Object, required: true })
], EprelQr.prototype, "product", void 0);
__decorate([
    property({ type: Object, required: true })
], EprelQr.prototype, "theme", void 0);
__decorate([
    property({ type: Object })
], EprelQr.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Object })
], EprelQr.prototype, "translations", void 0);
//# sourceMappingURL=EprelQr.js.map